import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function Register() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const { register } = useAuth();
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const res = await register(name, email, password);
    setLoading(false);
    if (res.ok) {
      toast.success("Account created!");
      navigate("/admin");
    } else {
      toast.error(res.error);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-brand-bg p-8" data-testid="register-page">
      <div className="w-full max-w-sm">
        <Link to="/" className="text-sm text-brand-muted hover:text-brand-primary transition-colors font-body" data-testid="back-to-clock-link">
          ← Back to time clock
        </Link>
        <h1 className="font-heading text-4xl font-light tracking-tight mt-8">Create account</h1>
        <p className="text-brand-muted font-body mt-2">Set up an admin login to manage your events.</p>

        <form onSubmit={submit} className="mt-10 space-y-5">
          <div>
            <Label htmlFor="name" className="overline block mb-2">Full name</Label>
            <Input
              id="name" data-testid="register-name-input"
              value={name} onChange={(e) => setName(e.target.value)}
              required className="h-12 bg-white border-brand-border font-body"
            />
          </div>
          <div>
            <Label htmlFor="email" className="overline block mb-2">Email</Label>
            <Input
              id="email" type="email" data-testid="register-email-input"
              value={email} onChange={(e) => setEmail(e.target.value)}
              required className="h-12 bg-white border-brand-border font-body"
            />
          </div>
          <div>
            <Label htmlFor="password" className="overline block mb-2">Password</Label>
            <Input
              id="password" type="password" data-testid="register-password-input"
              value={password} onChange={(e) => setPassword(e.target.value)}
              required minLength={6} className="h-12 bg-white border-brand-border font-body"
            />
          </div>
          <button
            type="submit" data-testid="register-submit-button" disabled={loading}
            className="w-full h-12 rounded-md bg-brand-primary text-white font-heading font-medium transition-colors hover:bg-brand-primaryHover disabled:opacity-50"
          >
            {loading ? "Creating…" : "Create account"}
          </button>
        </form>

        <p className="mt-6 text-sm text-brand-muted font-body">
          Already have an account?{" "}
          <Link to="/login" className="text-brand-primary hover:underline" data-testid="go-login-link">Sign in</Link>
        </p>
      </div>
    </div>
  );
}
